import React from "react";

interface ChartSkeletonProps {
  showLegend?: boolean;
}

const ChartSkeleton: React.FC<ChartSkeletonProps> = ({ showLegend = true }) => {
  return (
    <div className="h-full w-full flex flex-col">
      {showLegend ? (
        <div className="flex items-center justify-center gap-3 pt-1">
          <div className="h-3 w-28 rounded bg-gray-200 animate-pulse" />
          <div className="h-3 w-32 rounded bg-gray-200 animate-pulse" />
        </div>
      ) : null}
      <div className="flex-1 flex items-end justify-center gap-3 px-6 pb-20 pt-4">
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="w-6 rounded bg-gray-200 animate-pulse"
            style={{ height: `${24 + (i % 5) * 14}px` }}
          />
        ))}
      </div>
    </div>
  );
};

export default ChartSkeleton;

